import Layout from '@layout/Index'

export const projectTaskPackage = [
  {
    path: '/project-task-package',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "ProjectTaskPackageTable" */ './pages/ProjectTaskPackageTable.vue'),
        name: '任务包及培训配置',
        meta: {
          title: '任务包及培训配置',
        },
      },
      {
        path: 'config/:projectId',
        component: () => import(/* webpackChunkName: "ProjectTaskPackageConfig" */ './pages/ProjectTaskPackageConfig.vue'),
        name: '任务包配置',
        meta: {
          title: '任务包配置',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/project-task-package/project-task-package.route.js